<template>
  <div id="ag-grid-demo">
    <vx-card class="p-4 mb-6">
      <div class="flex flex-wrap items-center justify-between mb-10">
        <div class="flex items-center">
          <h4 style="margin-left: 10px">Menu</h4>
        </div>
        <div class="flex items-center">
          <vs-button @click="refreshData" class="btn mb-4 md:mb-0 mr-1" icon="refresh">Refresh</vs-button>
          <vs-button :to="{ name: 'menu-add' }" class="btn mb-4 md:mb-0 mr-1" icon="add">Add</vs-button>
          <vs-button
            :to="{ name: 'menu-view', params: {id: selectedId} }"
            class="mb-4 md:mb-0 mr-1"
            icon="remove_red_eye"
            :disabled="selectedId ? false : true"
          >View</vs-button>
          <vs-button
            class="mb-4 md:mb-0 mr-1"
            @click="removeItem"
            icon="delete"
            :disabled="selectedId ? false : true"
          >Delete</vs-button>
          <vs-button class="mb-4 md:mb-0 mr-1" icon="filter_list" @click="filterActive">Filter</vs-button>
        </div>
      </div>
      <ag-grid-vue
        :gridOptions="gridOptions"
        class="ag-theme-material w-100 my-4 ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="menus"
        colResizeDefault="shift"
        :animateRows="false"
        :floatingFilter="false"
        rowSelection="single"
        @selection-changed="onSelectionChanged"
        @rowDoubleClicked="viewData"
      ></ag-grid-vue>
      <p class="text-right">
        <b>Showing {{ dataFrom }} to {{ dataTo }} of {{ dataTotal }} total entries</b>
      </p>
      <vs-pagination :total="totalPage" v-model="currentPage"></vs-pagination>
      <vs-prompt @accept="filterData" title="Filter" :active.sync="showFilter">
        <div class="con-exemple-prompt">
          <vs-input placeholder="Module" v-model="filter.module" class="mt-4 mb-2 w-full" />
          <vs-input placeholder="Menu" v-model="filter.menu" class="mt-4 mb-2 w-full" />
          <vs-input placeholder="Path" v-model="filter.path" class="mt-4 mb-2 w-full" />
          <vs-input placeholder="Icon" v-model="filter.icon" class="mt-4 mb-2 w-full" />
          <v-select
            class="mt-4 mb-2 w-full"
            placeholder="Enable"
            :options="enables"
            v-model="filter.enable_filter"
            label="enable_name"
            :reduce="enable => enable.id"
          ></v-select>
          <v-select
            class="mt-4 mb-2 w-full"
            placeholder="Menu Type"
            :options="menu_types"
            v-model="filter.menu_type"
            label="menu_type"
            :reduce="menu_type_id => menu_type_id.id"
          ></v-select>
          <v-select
            class="mt-4 mb-2 w-full"
            placeholder="Parent"
            :options="parents"
            v-model="filter.parent_id"
            label="menu"
            :reduce="parent_id => parent_id.id"
          ></v-select>
        </div>
      </vs-prompt>
    </vx-card>
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuesax/extraComponents/agGridStyleOverride.scss";
import vSelect from "vue-select";

export default {
  components: {
    vSelect,
    AgGridVue
  },
  data() {
    return {
      gridOptions: {},
      gridApi: null,
      columnDefs: null,
      defaultColDef: {
        sortable: true,
        editable: false,
        resizable: true,
        suppressMenu: true
      },
      menus: [],
      filter: {
        module: "",
        menu: "",
        path: "",
        icon: "",
        sequence: "",
        enable_filter: "",
        menu_type: "",
        parent_id: ""
      },
      parents: [],
      enables: [
        {
          enable_name: "Yes",
          id: "yes"
        },
        {
          enable_name: "No",
          id: "no"
        }
      ],
      menu_types: [
        {
          menu_type: "Parent",
          id: "parent"
        },
        {
          menu_type: "Child",
          id: "child"
        }
      ],
      showFilter: false,
      selectedId: null,
      isLoading: false,
      totalPage: 1,
      currentPage: 1,
      dataFrom: 0,
      dataTo: 0,
      dataTotal: 0
    };
  },
  watch: {
    isLoading: function() {
      if (this.isLoading) {
        this.$vs.loading();
      } else {
        this.$vs.loading.close();
      }
    },
    currentPage: function() {
      this.fetchData();
    }
  },
  methods: {
    onSelectionChanged() {
      var selectedRows = this.gridApi.getSelectedRows();
      var selectedRowsString = "";
      selectedRows.forEach(function(selectedRow, index) {
        if (index !== 0) {
          selectedRowsString += ", ";
        }
        selectedRowsString += selectedRow.id;
      });
      this.selectedId = selectedRowsString;
    },
    refreshData() {
      this.fetchData();
    },
    fetchData() {
      this.isLoading = true;
      this.$http
        .post("rolemanagement/menu?page=" + this.currentPage, this.filter)
        .then(resp => {
          this.menus = resp.data.data.map(item => {
            return {
              id: item.id,
              enable: item.enable == 1 ? "Yes" : "No",
              icon: item.menu_type == "child" ? "-" : item.icon,
              menu: item.menu,
              menu_type: item.menu_type == "Parent" ? "Parent" : "Child",
              module: item.module,
              parent_menu: item.parent_menu ? item.parent_menu : "-",
              path: item.path
            };
          });

          this.totalPage = resp.data.last_page;
          this.dataTotal = resp.data.total;
          this.dataFrom = resp.data.from;
          this.dataTo = resp.data.to;
          this.currentPage = resp.data.current_page;
        })
        .catch(resp => {
          this.$vs.dialog({
            type: "confirm",
            color: "danger",
            title: resp,
            text: "Try again?",
            accept: () => {
              this.fetchData();
            },
            acceptText: "Yes",
            cancelText: "No"
          });
        })
        .then(() => (this.isLoading = false));
    },
    removeItem() {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: "Confirm",
        text: "Are you sure want to delete this Menu?",
        accept: this.acceptAlert
      });
    },
    acceptAlert() {
      this.isLoading = true;
      this.$http
        .delete("rolemanagement/menu/" + this.selectedId + "/destroy")
        .then(res => {
          this.$vs.notify({
            color: "success",
            title: "Menu deleted",
            iconPack: "feather",
            icon: "icon-check",
            text: "The selected Menu was successfully deleted"
          });
        })
        .catch(error => {
          this.$vs.notify({
            title: "Error",
            text: "Error.",
            color: "danger"
          });
        })
        .then(() => {
          this.fetchData();
        });
    },
    viewData() {
      this.$router.push({
        name: "menu-view",
        params: {
          id: this.selectedId
        }
      });
    },
    filterActive() {
      this.showFilter = true;
      this.$http
        .post("rolemanagement/menu/parent/dropdown")
        .then(resp => {
          this.parents = resp.data.data;
        })
        .catch(err => {
          this.$vs.notify({
            color: "danger",
            title: "Error",
            text: err
          });
        });
    },
    filterData() {
      this.currentPage = 1;
      this.fetchData();
    }
  },
  mounted() {
    this.fetchData();
    this.gridApi = this.gridOptions.api;
  },
  beforeMount() {
    this.columnDefs = [
      {
        headerName: "Module",
        field: "module",
        width: 150
        // checkboxSelection: true,
        // headerCheckboxSelectionFilteredOnly: true,
        // headerCheckboxSelection: true,
      },
      {
        headerName: "Menu Name",
        field: "menu",
        width: 150
      },
      {
        headerName: "Path",
        field: "path",
        width: 150
        // pinned: 'left'
      },
      {
        headerName: "Icon",
        field: "icon",
        width: 150
      },
      {
        headerName: "Enable",
        field: "enable",
        width: 150
      },
      {
        headerName: "Menu Type",
        field: "menu_type",
        width: 150
      },
      {
        headerName: "Parent",
        field: "parent_menu",
        width: 150
      }
    ];
  }
};
</script>